import { GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem, GlModalDirective, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { isEmpty } from 'lodash-es';
import { mergeUrlParams } from '~/lib/utils/url_utility';
import { s__, __ } from '~/locale';
import WorkItemByEmail from './work_item_by_email.vue?vue3';
import WorkItemCsvExportModal from './work_items_csv_export_modal.vue?vue3';
import WorkItemsCsvImportModal from './work_items_csv_import_modal.vue?vue3';
export default {
    name: 'WorkItemListActions',
    exportModalId: 'work-item-export-modal',
    importModalId: 'work-item-import-modal',
    components: {
        GlDisclosureDropdownItem,
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        WorkItemCsvExportModal,
        WorkItemsCsvImportModal,
        WorkItemByEmail
    },
    i18n: {
        exportAsCSV: s__('WorkItem|Export as CSV'),
        importFromJira: s__('WorkItem|Import from Jira'),
        importCsv: s__('WorkItem|Import CSV'),
        rssLinkUpdateError: s__('WorkItem|An error occurred updating the RSS link. Please refresh the page to try again.')
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective
    },
    inject: {
        projectImportJiraPath: {
            default: null
        },
        rssPath: {
            default: null
        },
        calendarPath: {
            default: null
        },
        canImportWorkItems: {
            default: false
        },
        canAdminProject: {
            default: false
        }
    },
    props: {
        workItemCount: {
            type: Number,
            required: false,
            default: undefined
        },
        queryVariables: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        canExport: {
            type: Boolean,
            required: false,
            default: false
        },
        fullPath: {
            type: String,
            required: false,
            default: ''
        },
        showWorkItemByEmailButton: {
            type: Boolean,
            required: false,
            default: false
        },
        urlParams: {
            type: Object,
            required: false,
            default: ()=>({})
        }
    },
    emits: [
        'error'
    ],
    data () {
        return {
            showTooltip: false
        };
    },
    computed: {
        importFromJira () {
            return {
                text: this.$options.i18n.importFromJira,
                href: this.projectImportJiraPath
            };
        },
        importCsv () {
            return {
                text: this.$options.i18n.importCsv
            };
        },
        exportAsCSV () {
            return {
                text: this.$options.i18n.exportAsCSV
            };
        },
        dropdownTooltip () {
            return !this.showTooltip ? __('More actions') : '';
        },
        filteredRssPath () {
            if (!this.rssPath) return null;
            if (isEmpty(this.urlParams)) return this.rssPath;
            try {
                return mergeUrlParams(this.urlParams, this.rssPath);
            } catch (error) {
                this.$emit('error', this.$options.i18n.rssLinkUpdateError);
                // Fall back to the original path if URL construction fails
                return this.rssPath;
            }
        },
        subscribeDropdownOptions () {
            return {
                items: [
                    {
                        text: __('Subscribe to RSS feed'),
                        href: this.filteredRssPath,
                        extraAttrs: {
                            'data-testid': 'subscribe-rss'
                        }
                    },
                    {
                        text: __('Subscribe to calendar'),
                        href: this.calendarPath,
                        extraAttrs: {
                            'data-testid': 'subscribe-calendar'
                        }
                    }
                ]
            };
        },
        hasSubscriptionOptions () {
            return this.filteredRssPath || this.calendarPath;
        },
        isJiraImportVisible () {
            return Boolean(this.projectImportJiraPath) && this.canAdminProject;
        },
        canImport () {
            return this.isJiraImportVisible || this.canImportWorkItems;
        },
        hasImportExportOptions () {
            return Boolean(this.canExport || this.canImport);
        },
        shouldShowDropdown () {
            return this.hasImportExportOptions || this.hasSubscriptionOptions || this.showWorkItemByEmailButton;
        }
    },
    methods: {
        showDropdown () {
            this.showTooltip = true;
        },
        hideDropdown () {
            this.showTooltip = false;
        }
    }
};
